/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Load_Project_File_Read_Failed_ToastInputs */

const en_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project file read failed. ${i?.error}`)
};

const fr_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de lecture du fichier projet. ${i?.error}`)
};

const de_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektdatei konnte nicht gelesen werden. ${i?.error}`)
};

const it_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lettura del file di progetto non riuscita. ${i?.error}`)
};

const ru_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка чтения файла проекта. ${i?.error}`)
};

const es_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la lectura del archivo del proyecto. ${i?.error}`)
};

const zh_cn2_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目文件读取失败。${i?.error}`)
};

const ja_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトファイルの読み取りに失敗しました。${i?.error}`)
};

const hi_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल पढ़ने में विफलता। ${i?.error}`)
};

const pt_pt2_load_project_file_read_failed_toast = /** @type {(inputs: Load_Project_File_Read_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na leitura do arquivo do projeto. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Project file read failed. {error}" |
*
* @param {Load_Project_File_Read_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_read_failed_toast = /** @type {((inputs: Load_Project_File_Read_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Read_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_read_failed_toast(inputs)
	if (locale === "de") return de_load_project_file_read_failed_toast(inputs)
	if (locale === "it") return it_load_project_file_read_failed_toast(inputs)
	if (locale === "ru") return ru_load_project_file_read_failed_toast(inputs)
	if (locale === "es") return es_load_project_file_read_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_read_failed_toast(inputs)
	if (locale === "ja") return ja_load_project_file_read_failed_toast(inputs)
	if (locale === "hi") return hi_load_project_file_read_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_read_failed_toast(inputs)
	return en_load_project_file_read_failed_toast(inputs)
});